<mat-toolbar color="accent">
  <button id="goToPanelButtonShowEdit" mat-icon-button (click)="goToPanel()">
    <mat-icon class="icon-ic_arrow_back" color="secundary"></mat-icon>
  </button>
  <span>{{ 'request.detail.title' | translate }}</span>
</mat-toolbar>
<scf-request-header
  [numRequest]="operation.numOperation"
  [documentation]="listDocumentation"
  [state]="state"
  [operative]="operative"
  [operation]="operation"
></scf-request-header>
<mat-tab-group [selectedIndex]="selectedIndex" color="accent">
  <mat-tab label="{{ 'request.tabs.request' | translate | uppercase }}">
    <app-request
      *ngIf="requestForm && requestData"
      [mode]="mode"
      [state]="state"
      [operativeShowEdit]="operative"
      [request]="requestData"
      [hostStatus]="hostStatus"
      (isFinishedLoading)="changeRequestStatusLoading($event)"
    ></app-request>
    <app-request-auto
      *ngIf="requestAutoForm && requestData"
      [mode]="mode"
      [state]="state"
      [operative]="operative"
      [request]="requestData"
      [hostStatus]="hostStatus"
      (isFinishedLoading)="changeRequestStatusLoading($event)"
    ></app-request-auto>
    <app-request-bp
      *ngIf="requestBPForm && requestData"
      [mode]="mode"
      [state]="state"
      [request]="requestData"
      (isFinishedLoading)="changeRequestStatusLoading($event)"
    ></app-request-bp>
    <app-request-mg
      *ngIf="requestMgForm && requestData"
      [mode]="mode"
      [state]="state"
      [request]="requestData"
      (isFinishedLoading)="changeRequestStatusLoading($event)"
    ></app-request-mg>
    <app-request-mg-no-shopping
      *ngIf="requestMgNoShopForm && requestData"
      [mode]="mode"
      [state]="state"
      [request]="requestData"
      (isFinishedLoading)="changeRequestStatusLoading($event)"
    ></app-request-mg-no-shopping>
  </mat-tab>
  <mat-tab label="{{ 'request.tabs.documetation' | translate | uppercase }}">
    <scf-request-documentation
      *ngFor="let intervinient of listDocumentation"
      [documentation]="intervinient.documentsConsultationList"
      [operation]="operation"
      [docId]="intervinient.docId"
    ></scf-request-documentation>
  </mat-tab>
  <ng-container *ngIf="isAttrHistoric()">
    <mat-tab label="{{ 'request.tabs.historical' | translate | uppercase }}">
      <scf-historical [numOperation]="operation.numOperation"></scf-historical>
    </mat-tab>
  </ng-container>
  <ng-container *ngIf="isAttrViewTraces()">
    <mat-tab label="{{ 'request.tabs.trace' | translate | uppercase }}" *ngIf="isAttrViewTraces()">
      <scf-traces [numOperation]="operation.numOperation"></scf-traces>
    </mat-tab>
  </ng-container>
</mat-tab-group>
